<template>
  <div class="large-layout">
    <navbar/>
    <div class="main-container">
      <div class="container-fluid">
        <child/>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/Navbar'
import { mapGetters } from 'vuex'


export default {
  name: 'LargeLayout',

  components: {
    Navbar
  },

  computed: mapGetters({
    user: 'auth/user'
  }),
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/layouts/large.vue